import React, { useState, useEffect, useContext, useRef } from 'react'
import { Functionality } from '../context/Functionality.js'
import Sidebar from './Sidebar';
import { FaBars, FaTimes } from 'react-icons/fa';

export default function EmployeePortal({ children }) {

    const { getAllBusinesses } = useContext(Functionality)

    useEffect(() => {
        getAllBusinesses()
    }, []);

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const sidebarRef = useRef(null);

    // Toggle the sidebar when the button is clicked
    const toggleSidebar = () => {
        setIsSidebarOpen((prevState) => !prevState);
    };

    // Close sidebar on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check if the click is outside the sidebar
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setIsSidebarOpen(false);
            }
        };

        // Add event listener for click events
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener when the component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [sidebarRef]);

    return (
        <>
            <div className="flex flex-col md:flex-row h-screen overflow-x-hidden">
                {/* Sidebar */}
                <div
                    ref={sidebarRef}
                    className={`fixed inset-x-0 bottom-0 top-16 z-30 transform transition-transform duration-300 bg-[#0e2234] w-60 shrink-0 md:h-full overflow-y-auto sidebar md:relative md:top-0 md:translate-x-0 ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
                        }`}
                >
                    <Sidebar toggleSidebar={toggleSidebar} />
                </div>

                {/* Main Content Area */}
                <div className="flex-1 min-w-0" >
                    <div className="min-h-screen flex flex-col">
                        <div className="flex-1 p-4">
                            <button type="button" onClick={toggleSidebar} aria-label="Toggle employee sidebar" aria-expanded={isSidebarOpen} className="mb-4 p-2 md:hidden">
                                {isSidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                            </button>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}